import api from './api'

/**
 * Serviço de upload de avatar/logo do Tenant
 */
export default {
  /**
   * Upload de avatar/logo do tenant
   * @param {File} file - Arquivo de imagem
   * @returns {Promise<string>} URL da imagem no Cloudinary (TEXT_PLAIN)
   */
  /**
   * Upload de avatar/logo do tenant
   * @param {File} file - Arquivo de imagem
   * @param {string} tenantId - ID do tenant
   * @returns {Promise<string>} URL da imagem no Cloudinary (TEXT_PLAIN)
   */
  uploadAvatar(file, tenantId) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('tenantId', tenantId)
    return api.post('/api/tenant/avatar/upload', formData, {
      headers: {
        'Content-Type': undefined,
      },
      responseType: 'text',
    })
  },

  /**
   * Upload de favicon do tenant
   * @param {File} file - Arquivo de imagem (favicon)
   * @param {string} tenantId - ID do tenant
   * @returns {Promise<string>} URL do favicon no Cloudinary (TEXT_PLAIN)
   */
  uploadFavicon(file, tenantId) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('tenantId', tenantId)
    return api.post('/api/tenant/avatar/favicon', formData, {
      headers: {
        'Content-Type': undefined,
      },
      responseType: 'text',
    })
  },
}
